import { render, staticRenderFns } from "./AwkPause.vue?vue&type=template&id=7a6cf834&scoped=true&"
import script from "./AwkPause.vue?vue&type=script&lang=ts&"
export * from "./AwkPause.vue?vue&type=script&lang=ts&"
import style0 from "./AwkPause.vue?vue&type=style&index=0&id=7a6cf834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6cf834",
  null
  
)

export default component.exports